var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacilityUserAccounts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.75,11.79c.27.14.52.31.76.49l-.03-7.28h-3.08v.8h2.35v5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.59,19.89h-2.79v-4.7h2.4c.09-.28.2-.54.33-.8h-3.53v5.5h-3.08l-.07-.07V1.16l.07-.07h10.93v10.07c.25-.04.5-.07.75-.09V.3H5.1v19.59H1.95V5.79h2.35v-.8H1.22l-.07,14.89H0s0,.8,0,.8h13.1c-.19-.25-.36-.52-.51-.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.6,23.7c-3.53,0-6.4-2.87-6.4-6.4s2.87-6.4,6.4-6.4,6.4,2.87,6.4,6.4-2.87,6.4-6.4,6.4ZM17.6,11.69c-3.09,0-5.61,2.52-5.61,5.61s2.52,5.61,5.61,5.61,5.61-2.52,5.61-5.61-2.52-5.61-5.61-5.61Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mHKKd4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.54,21.52c.02-1.47.82-2.81,2.1-3.53.18.14.35.25.55.36-1.16.53-1.99,1.54-2.13,3.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.66,21.52c-.02-1.47-.82-2.81-2.1-3.53-.18.14-.35.25-.55.36,1.16.53,2.19,1.78,2.14,3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.34,13.1c1.38-.16,2.6.84,2.75,2.19.15,1.36-.83,2.59-2.19,2.74s-2.57-.82-2.74-2.17c-.16-1.35.8-2.6,2.18-2.76ZM17.43,13.67c-1.06.11-1.81,1.06-1.71,2.09s1.05,1.82,2.1,1.71,1.8-1.04,1.7-2.08-1.03-1.83-2.09-1.72Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacilityUserAccounts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facility-user-accounts.3fabbde687f80119d29426001192010d.svg";